var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgChatOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0484 0C18.2308 0 20 1.76919 20 3.9516V14.6198L15.2422 11.2894C15.0931 11.185 14.9155 11.129 14.7335 11.129H9.5968C7.41439 11.129 5.64519 9.35982 5.64519 7.1774V3.95161C5.64519 1.76919 7.41439 0 9.5968 0H16.0484ZM18.5484 3.9516C18.5484 2.5709 17.4291 1.45161 16.0484 1.45161H9.5968C8.21609 1.45161 7.0968 2.5709 7.0968 3.95161V7.1774C7.0968 8.55811 8.21609 9.6774 9.5968 9.6774H14.7335C15.2134 9.6774 15.6816 9.825 16.0747 10.1002L18.5484 11.8318V3.9516ZM0 8.79031C0 6.63483 1.7258 4.88243 3.871 4.83951V6.29158C2.5276 6.33414 1.45161 7.43657 1.45161 8.79031V16.6705L3.92532 14.9389C4.31842 14.6637 4.78664 14.5161 5.26648 14.5161H10.4032C11.4715 14.5161 12.3833 13.846 12.7412 12.9032H14.2548C13.8522 14.6585 12.2806 15.9677 10.4032 15.9677H5.26648C5.08447 15.9677 4.90687 16.0237 4.75776 16.1281L0 19.4585V8.79031Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOutlined);
export default __webpack_public_path__ + "static/media/chatOutlined.ae484c04363ed62a759e0dfc8c1a647e.svg";
export { ForwardRef as ReactComponent };